import React from "react";
import SwoodleLogo from "../../Assets/Icons/SwoodleUpdatedLogo.svg";
import PrimaryOutlineButton from "./PrimaryOutlineButton";
import PrimaryButton from "./PrimaryButton";
import { logout } from "../../services/authService";
import { getFcmToken } from "../../utils/connectStore";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const Header = ({ btn, handleSaveAndExit, stepIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRole = useSelector((state) => state?.authReducer?.tokenData?.user?.role);

  const handleLogoutClick = async () => {
    const logoutPromise = await dispatch(
      logout({ fcmToken: getFcmToken() })
    )?.unwrap();
    if (logoutPromise?.success === true) {
      // Always redirect to main login page
      navigate("/", { replace: true });
    }
  };

  return (
    <div className="w-full h-[30%] bg-[#FFFFFF] px-[2%] py-[1%] drop-shadow-[0_4px_10px_rgba(0,0,0,0.05)] flex items-center justify-between">
      <a href="https://swoodle.com.au/" target="_blank" rel="noopener noreferrer">
        <img
          className="w-[120px] sm:w-[160px] md:w-[200px] lg:w-[220px] h-auto"
          src={SwoodleLogo}
          alt="Swoodle"
        />
      </a>
      <div className="flex justify-end items-center gap-3">
        <PrimaryButton
          label={"Logout"}
          className={
            "w-full text-[14px] font-[500] font-poppins px-2 py-2 h-[40px] md:h-[45px] rounded-[10px]"
          }
          onClick={handleLogoutClick}
        />
      {btn && stepIndex !== 1 && (
        <PrimaryOutlineButton
          label={"Save and Exit"}
          className={
            "w-full text-[14px] font-[500] px-2 py-2 h-[40px] sm:h-[40px] md:h-[45px] rounded-[10px] whitespace-nowrap"
          }
          onClick={handleSaveAndExit}
        />
      )}
      </div>
    </div>
  );
};

export default Header;